import { Partner, Society } from 'types';

export const getPartnerFromParticipant = (
  participant: any,
  actualSociety: Society
): Partner | undefined =>
  actualSociety?.partners.find(
    (partner: any) => partner['_id'] === participant.member
  );
